import { ref } from 'vue'
import { baseUrl } from '@/core/utils'

export type NameButtonProps = {
  src: string
}

export function useNameButton(props: NameButtonProps) {
  const { src } = props
  const image = getNameImage(src)

  return {
    image,
  }
}

// -----------------------------------------------
function getNameImage(src: string) {
  const name = src
  const hilight = name.replace('.png', '-a.png')
  return { name, hilight }
}

// -----------------------------------------------
